import * as yup from "yup";
import { emailCheck, phoneCheck } from "../../common/regex";

export const validationSchema = yup.object().shape({
  bookingName: yup.string().required("Booking Name is required"),
  bookingNumber: yup.string().required("Booking Number is required"),
  bookingType: yup.string().required("Booking Type is required"),
  startDate: yup.string().required("Start Date is required"),
  endDate: yup.string().required("Date is required"),
  movementMode: yup.string().required("Movement Mode is required"),
  bookingCreatedBy: yup.string().required("Booking Created By is required"),
  indentType: yup.string().required("Indent Type is required"),

//   clent details
consignorDetails: yup.array().of(
  yup.object().shape({
    companyName: yup.string().required("Company Name is required"),
    executive: yup.string().required("Executive Name is required"),
    contactNumber: yup
      .string()
      .matches(phoneCheck, "Please enter a valid phone number")
      .required("Phone number is required "),
    emailId: yup
      .string()
      .required("Email is required")
      .matches(
        emailCheck,
        "Please provide a valid email address")
  })
),
consigneeDetails: yup.array().of(
  yup.object().shape({
    companyName: yup.string().required("Company Name is required"),
    executive: yup.string().required("Executive Name is required"),
    contactNumber: yup
      .string()
      .matches(phoneCheck, "Please enter a valid phone number")
      .required("Phone Number is required"),
      emailId: yup
      .string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please provide a valid email address")
  })
),
clientDetail: 
  yup.object().shape({
    clientId: yup.string().required("Company Name is required"),
    executive: yup.string().required("Executive Name is required"),
    contactNumber: yup
      .string()
      .matches(phoneCheck, "Please enter a valid phone number")
      .required("Phone Number is required"),
      emailId: yup
      .string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please provide a valid email address")
  }),
vehicleDetails: yup.array().of(
  yup.object().shape({
    vehicleCount: yup
      .string()
      .optional()
      .matches(/^[0-9]+$/, "Only numbers are allowed"),
    vehicleSpecification: yup
      .string()
      .max(500, "Max 500 characters allowed"),
    vehicleMode: yup.string(),
    vehicleType: yup.string(),

    remarks: yup
    .string()
    .max(500, "Max 500 characters allowed"),
  })
),
containerDetails: yup.array().of(
  yup.object().shape({
    containerType: yup.string(),
    containerSize: yup.string(),
    noOfContainer: yup
      .number()
      .typeError("Number of Containers must be a number")
      .min(1, "Number of Containers must be at least 1"),
    containerSpecification: yup
    .string()
    .max(500, "Max 500 characters allowed"),
    remarks: yup
    .string()
    .max(500, "Max 500 characters allowed"),
  })
),
// cargo details
cargoDetails: yup.array().of(
  yup.object().shape({
    cargo: yup.string(),
    subCargo: yup.string(),
    cargoType: yup.string(),
    volume: yup
    .string(),
     weight: yup
    .string(),
   
      count: yup
    .string(),
      
    packageType: yup.string(),
   
    cargoDescription: yup
    .string()
    .max(500, "Max 500 characters allowed"),
    remarks: yup
    .string()
    .max(500, "Max 500 characters allowed"),
  })
),
  // Billing Address
  billingAddressLine1: yup.string(),
  billingAddressLine2: yup.string(),
  billingCity: yup.string(),
  billingPincode: yup
  .string()
  .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
  billingState: yup.string(),
  billingCountry: yup.string(),
  billingPhoneNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Please enter your PhoneNumber"),
    billingEmail: yup
    .string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please provide a valid email address"
    ),

    shippingDetails: yup.array().of(
      yup.object().shape({
        addressLine1: yup.string(),
        addressLine2: yup.string().notRequired(),
        city: yup.string(),
        pincode: yup
          .string()
          .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
        state: yup.string(),
        country: yup.string(),
        phoneNumber: yup
          .string()
          .matches(/^\d{10}$/, "Please enter your PhoneNumber"),
        email: yup
          .string()
          .email("Enter a valid email address"),
      })
    ),

});
